
import { type ChapterElement, type CellElement, type DocumentationLayoutCell, type CodeLayoutCell, type SimulationLayoutCell, type AchievementLayoutCell } from "@/types";
import { useEditorState } from "@/store";
import i18n from "@/i18n";
export const yamlChapterToLayout = (chapter: ChapterElement) => {
  if (!chapter) return;
  const { configJson, language } = useEditorState.getState();

  const layout: any = {
    "simulationWorkspace":
    {
      "blocks": [] as any[]
    },
    "mainWorkspace":
    {
      "blocks": [] as any[]

    },
    "secondaryWorkspace":
    {
      "blocks": [] as any[]
    }
  };

  if (useEditorState.getState().backwardCompatibility && chapter.config) {
    Object.keys(chapter.config).forEach((key) => {
      layout[key] = {
        ...chapter.config![key],
        blocks: []
      };
    });
  }

  const documentationCells: DocumentationLayoutCell[] = [];
  const codeCells: CodeLayoutCell[] = [];
  const simulationCells: SimulationLayoutCell[] = [];
  const achievementCells: AchievementLayoutCell[] = [];
  const qaCells: any[] = [];

  chapter.cells.forEach((cell: CellElement) => {
    if (cell.type.toLowerCase() === "documentation") {
      documentationCells.push(cell as DocumentationLayoutCell);
    } else if (cell.type.toLowerCase() === "code") {
      codeCells.push(cell as CodeLayoutCell);
    } else if (cell.type.toLowerCase() === "qa") {
      qaCells.push(cell);
    } else if (cell.type.toLowerCase() === "simulation") {
      simulationCells.push(cell as SimulationLayoutCell);
    } else if (cell.type.toLowerCase() === "achievement") {
      achievementCells.push(cell as AchievementLayoutCell);
    }
  });

  for (const cell of simulationCells) {
    if (cell.config?.tabsetId && cell.config?.dockLocation) {
      layout[cell.config.tabsetId].blocks.push({
        "type": "Simulation",
        "id": "main-godot-tab",
        "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || i18n.t("Simulation"),
        "config": {
          "dockLocation": cell.config.dockLocation,
          "module": cell.module,
          "tabIcon": cell.config?.tabIcon
        }
      });
    } else {
      layout.simulationWorkspace.blocks.push({
        "type": "Simulation",
        "id": "main-godot-tab",
        "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || i18n.t("Simulation"),
        "config": {
          "module": cell.module,
          "tabIcon": cell.config?.tabIcon
        }
      });
    }
  }

  for (const cell of codeCells) {
    const file_path = configJson?.language === "ino" || configJson?.language === "cpp" ? `/usercode/${cell.sourceCode}.ino` : `/usercode/${cell.sourceCode}.py`;
    if (configJson?.dev === "code") {
      if (cell.config?.tabsetId && cell.config?.dockLocation) {
        layout[cell.config.tabsetId].blocks.push({
          "type": "Editor",
          "id": "main-editor-tab",
          "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || i18n.t("Editor"),
          "config": {
            "file_path": file_path,
            "initialCode": cell.defaultCode || configJson?.defaultCode,
            "preview": true,
            "dockLocation": cell.config.dockLocation,
            "tabIcon": cell.config?.tabIcon
          }
        });
      } else {
        layout.mainWorkspace.blocks.push({
          "type": "Editor",
          "id": "main-editor-tab",
          "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || i18n.t("Editor"),
          "config": {
            "file_path": file_path,
            "initialCode": cell.defaultCode || configJson?.defaultCode,
            "preview": true,
            "tabIcon": cell.config?.tabIcon
          }
        });
      };
    } else if (configJson?.dev === "blockly") {
      if (cell.config?.tabsetId && cell.config?.dockLocation) {
        layout[cell.config.tabsetId].blocks.push(
          {
            "type": "Blockly",
            "id": "main-blockly-tab",
            "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || i18n.t("Blockly"),
            "config": {
              "file_path": file_path,
              "xml_file_path": `/usercode/${cell.sourceXml}.xml`,
              "initialXML": cell.defaultXml || configJson?.defaultCodeXML,
              "plugins": ["field-angle", "field-colour", "field-slider"],
              "config": {},
              "dockLocation": cell.config.dockLocation,
              "tabIcon": cell.config?.tabIcon
            }
          },
          {
            "id": "blockly-preview-tab",
            "type": "Editor",
            "name": i18n.t("BLOCKLY_PREVIEW_KEY"),
            "config": {
              "file_path": file_path,
              "readonly": true,
              "dockLocation": cell.config.dockLocation,
              "tabIcon": cell.config?.tabIcon
            }
          }
        );
      } else {
        layout.mainWorkspace.blocks.push(
          {
            "type": "Blockly",
            "id": "main-blockly-tab",
            "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || i18n.t("Blockly"),
            "config": {
              "file_path": file_path,
              "xml_file_path": `/usercode/${cell.sourceXml}.xml`,
              "initialXML": cell.defaultXml || configJson?.defaultCodeXML,
              "plugins": ["field-angle", "field-colour", "field-slider"],
              "config": {},
              "tabIcon": cell.config?.tabIcon
            }
          },
          {
            "id": "blockly-preview-tab",
            "type": "Editor",
            "name": i18n.t("BLOCKLY_PREVIEW_KEY"),
            "config": {
              "file_path": file_path,
              "readonly": true,
              "tabIcon": cell.config?.tabIcon
            }
          }
        );
      }
    } else {
      if (cell.config?.tabsetId && cell.config?.dockLocation) {
        layout[cell.config.tabsetId].blocks.push({
          "type": "Editor",
          "id": "main-editor-tab",
          "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || i18n.t("Editor"),
          "config": {
            "file_path": file_path,
            "initialCode": cell.defaultCode || configJson?.defaultCode,
            "preview": true,
            "dockLocation": cell.config.dockLocation,
            "tabIcon": cell.config?.tabIcon
          }
        });
      } else {
        layout.mainWorkspace.blocks.push({
          "type": "Editor",
          "id": "main-editor-tab",
          "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || i18n.t("Editor"),
          "config": {
            "file_path": file_path,
            "initialCode": cell.defaultCode || configJson?.defaultCode,
            "preview": true,
            "tabIcon": cell.config?.tabIcon
          }
        });
      };
    }
  }

  //TODO(Baturay):: Asign name for quiz tab.
  for (const cell of qaCells) {
    if (cell.config?.tabsetId && cell.config?.dockLocation) {
      layout[cell.config.tabsetId].blocks.push({
        "type": "QA",
        "id": "quiz-tab",
        "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || " ",
        "config": {
          "quizId": cell.quizId,
          "dockLocation": cell.config.dockLocation,
          "tabIcon": cell.config?.tabIcon
        }
      });
    } else {
      layout.mainWorkspace.blocks.push({
        "type": "QA",
        "id": "quiz-tab",
        "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || " ",
        "config": {
          "quizId": cell.quizId,
          "tabIcon": cell.config?.tabIcon
        }
      });
    }
  }

  for (const cell of achievementCells) {
    if (cell.config?.tabsetId && cell.config?.dockLocation) {
      layout[cell.config.tabsetId].blocks.push({
        "type": "Achievement",
        "id": "achievement-tab",
        "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || " ",
        "config": {
          "achievement_id": cell.achievementId,
          "dockLocation": cell.config.dockLocation,
          "tabIcon": cell.config?.tabIcon
        }
      });
    } else {
      layout.secondaryWorkspace.blocks.push({
        "type": "Achievement",
        "id": "achievement-tab",
        "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || " ",
        "config": {
          "achievement_id": cell.achievementId,
          "tabIcon": cell.config?.tabIcon
        }
      });
    }
  }

  for (const cell of documentationCells) {
    // console.log("Documentation Cell : ", JSON.stringify(cell));
    const srcRelativePath = (language === "en" && cell.relativePathEn) ? cell.relativePathEn : cell.relativePath;
    const src = srcRelativePath ? `${configJson?.documentationUrl?.replace("index.html", "")}${srcRelativePath}` : configJson?.documentationUrl;


    if (cell.config?.tabsetId && cell.config?.dockLocation) {
      layout[cell.config.tabsetId].blocks.push({
        "type": "MiniBrowser",
        "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || " ",
        "config": {
          "src": src,
          "dockLocation": cell.config.dockLocation,
          "tabsetId": cell.config.tabsetId,
          "tabIcon": cell.config?.tabIcon,
          "weight": cell.config?.weight
        }
      });
    } else {
      layout.secondaryWorkspace.blocks.push({
        "type": "MiniBrowser",
        "name": (language === "tr" ? cell.config?.tabTitle : cell.config?.tabTitleEn) || " ",
        "config": {
          "src": src,
          "tabIcon": cell.config?.tabIcon,
          "weight": cell.config?.weight
        }
      });
    }
  }



  return layout;
}
